export default __webpack_public_path__ + "static/media/about.10eae0fe.jpg";